import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { JsonPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { OfficeService } from '../../services/office.service';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [JsonPipe, RouterLink, MatCardModule, MatButtonModule],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
})
export class AccountComponent implements OnInit {
  authService = inject(AuthService);
  officeService = inject(OfficeService);

  testResult = {};

  private router: Router = inject(Router);

  ngOnInit(): void {
    if (this.authService.userCredential() === null) {
      this.router.navigate(['auth']);
    }
  }

  loadOfficeDate(officeId: string): void {
    console.log('input ', officeId);
    this.testResult = {};
    this.officeService.getOfficeTest(
      officeId,
      res => {
        console.log('res ', res);
        this.testResult = res as object;
      },
      error => {
        console.log('res ', error);
        this.testResult = error as object;
      }
    );
  }

  logout() {
    this.authService.logout();
  }
}
